
import { BrowserModule } from '@angular/platform-browser'
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { APP_ROUTES } from './../app/app.routes';

import { PagesModule } from './pages/pages.module';

import { ServicesModule } from './services/services.module';

import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabase } from '@angular/fire/database';
import { environment } from './services/settings/firebase';
import { YouTubePlayerModule } from '@angular/youtube-player';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    APP_ROUTES,
    PagesModule,
    ServicesModule,
    AngularFireModule.initializeApp(environment.firebase),
    YouTubePlayerModule
  ],
  exports: [
    YouTubePlayerModule
  ],
  providers: [
    AngularFireDatabase
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
